import React from "react";

const CoinLink = ({ imgURL, label, href }) => (
  <div className="col-6 col-lg-2">
    <img src={imgURL} alt={""} className="img-fluid mx-auto d-block" />
    <div className="text-center mt-3">
      <a className="faq-bottom-link" href={href}>
        {label} &#187;
      </a>
    </div>
  </div>
);

const CoinLinkList = ({ coins }) => {
  return (
    <>
      {coins && (
        <div className="row justify-content-center">
          {coins.map(({ node: { acfPartials: coin } }, i) => (
            <CoinLink
              key={i}
              imgURL={coin.pIcon.localFile.publicURL}
              label={coin.pButtonText}
              href={coin.pButtonUrl}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default CoinLinkList;
